define('models/auth/registration-confirm',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var RegistrationConfirm = Model.extend({

        urlPath: '/api/registration/finish',

        defaults: {
            token: '',
            password: ''
        }
    });

    return RegistrationConfirm;
});
